import type { GraphNode } from './types'

interface Props {
  node: GraphNode
  x: number
  y: number
  visited: boolean
  focused: boolean
}

/**
 * One actor card. Rendered as DOM (not SVG) so the card layer can sit above the
 * tracer layer and occlude dots passing behind it.
 */
export function NodeCard({ node, x, y, visited, focused }: Props) {
  const classes = [
    'tl-node',
    `tl-node--${node.role}`,
    focused ? 'tl-node--focus' : '',
    node.primary ? 'tl-node--primary' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={classes}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        opacity: visited ? 1 : 0.08,
      }}
      aria-hidden="true"
    >
      <span className="tl-node__kind">{node.tag}</span>
      <span className="tl-node__name">{node.name}</span>
    </div>
  )
}
